export default __webpack_public_path__ + "static/media/awaaz.283d10c3.png";